import { Injectable, Injector } from '@angular/core';
import { BullhornTriggerConfigService } from '../../components/workflow-config/actions/actionConfigs/bullhorn-trigger-config.service';
import { ITriggerConfigService } from '../../components/workflow-config/actions/actionConfigs/itriggerconfig.service';
import { BullhornDocMergeAllowedEntitiesService } from '../../components/workflow-config/allowedEntities/BullhornDocMergeAllowedEntitiesService';
import { IDocMergeAllowedEntitiesService } from '../../components/workflow-config/allowedEntities/IDocMergeAllowedEntitiesService';
import {
  BullhornDocMergeAllowedSectionsService
} from '../../components/workflow-config/allowedSections/BullhornDocMergeAllowedSectionsService';
import { ISignatureDataFormatterService } from '../../interfaces/ISignatureDataFormatterService';
import { IDocumentDestinationService } from '../../model/interfaces/idocumentdestinationservice';
import { BullhornAttachmentSourceOptionLabelService } from '../attachment-source-options/bullhorn-attachment-source-option-label.service';
import { IAttachmentSourceOptionLabelService } from '../attachment-source-options/iattachment-source-option-label.service';
import { BullhornDocumentDestinationService } from '../document-destination/bullhorn.document-destination.service';
import { BullhornSignatureFormatterService } from '../signature-formatters/bullhorn-signature-formatter.service';
import { IServiceProviderService } from './iserviceproviderservice';

@Injectable({ providedIn: 'root' })
export class BullhornServiceProviderService implements IServiceProviderService {
  constructor(private injector: Injector) {}

  getDocumentDestinationService(): IDocumentDestinationService {
    return this.injector.get(BullhornDocumentDestinationService);
  }

  getSignatureDataFormatterService(): ISignatureDataFormatterService {
    return this.injector.get(BullhornSignatureFormatterService);
  }

  getTriggerConfigService(): ITriggerConfigService {
    return this.injector.get(BullhornTriggerConfigService);
  }

  getDocMergeAllowedEntitiesService(): IDocMergeAllowedEntitiesService {
    return this.injector.get(BullhornDocMergeAllowedEntitiesService);
  }

  getDocMergeAllowedSectionsService(): BullhornDocMergeAllowedSectionsService {
    return this.injector.get(BullhornDocMergeAllowedSectionsService);
  }

  getAttachmentSourceOptionLabelService(): IAttachmentSourceOptionLabelService {
    return this.injector.get(BullhornAttachmentSourceOptionLabelService);
  }
}
